/**
 * LCW — Antecipa o carregamento de "Complete sua rotina" (product-recommendations).
 *
 * O Horizon só busca as recomendações quando a seção chega a 400px da tela; numa PDP longa, no celular,
 * o cliente chega lá e vê a área vazia por ~1–1,5 s (fetch ~0,45 s + render). Aqui disparamos o carregamento
 * a ~1600px de distância (≈ 2 telas). O componente nativo recarrega quando qualquer atributo `data-*` muda
 * (MutationObserver em product-recommendations.js) — usamos isso em vez de tocar no arquivo nativo.
 * Se o Horizon mudar esse comportamento, o pior caso é voltar ao lazy-load padrão.
 * Carregado pelo bloco de preço (snippets/lcw-payment-info, part 'price'), só na PDP.
 */
const PREFETCH_MARGIN = '0px 0px 1600px 0px';

function prefetch(el) {
  if (el.dataset.recommendationsPerformed === 'true' || el.dataset.lcwPrefetch) return;
  el.dataset.lcwPrefetch = '1';
}

function init() {
  const targets = document.querySelectorAll('product-recommendations');
  if (!targets.length) return;
  if (!('IntersectionObserver' in window)) return; // fica o comportamento nativo
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        prefetch(/** @type {HTMLElement} */ (e.target));
      });
    },
    { rootMargin: PREFETCH_MARGIN }
  );
  targets.forEach((el) => io.observe(el));
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
